export default __webpack_public_path__ + "static/media/3.540a91fb.jpg";